import { runInAction } from 'mobx';
import ModeloDocumentoApi from '../api/ModeloDocumentoApi';
import ProcessoApi from '../api/ProcessoApi';
import { IModelo } from '../modelo';
import { UsuarioStore } from '../store';
import GabineteStore from '../store/GabineteStore';
import MensagemStore from '../store/MensagemStore';
import ParametroStore from '../store/ParametroStore';
import MinutaService from "./MinutaService";

class ModeloDocumentoService {


    carregaModelos = async () => {
        const modelos = [];
        let tiposMinuta = ParametroStore.tiposMinuta;
        if (tiposMinuta.length === 0) {
            tiposMinuta = await MinutaService.getTiposMinuta();
            if (tiposMinuta.length === 0) {
                MensagemStore.apresentarErro('Não foi possível carregar os tipos de minuta, tente entrar voltar novamente a esta tela ou entre em contato com o suporte(4040).');
            } else {
                runInAction(() => {
                    ParametroStore.tiposMinuta = tiposMinuta;
                });
            }
        }
        if (GabineteStore.unidadesDePublicacao.length === 0) {
            try {
                const unidades = await ProcessoApi.carregarTodasUnidadesPublicacao();
                if (unidades?.length > 0) {
                    runInAction(() => {
                        GabineteStore.unidadesDePublicacao = unidades;
                    });
                }
            } catch (e) {
                console.error('[ModeloDocumentoService] Falha ao carregar unidades de publicação:', e);
            }
        }
        const resultados = await Promise.allSettled(tiposMinuta.map(async (tipo) => {
            const modelosDoTipo = await this.modelosDoGabinetePorTipo(UsuarioStore.gabinete, tipo.codigo);
            return { tipo, modelosDoTipo };
        }));
        const tiposComFalha: string[] = [];
        resultados.forEach((resultado, indice) => {
            if (resultado.status === 'fulfilled') {
                modelos.push(...resultado.value.modelosDoTipo);
            } else {
                const tipo = tiposMinuta[indice];
                tiposComFalha.push(tipo?.descricao || String(tipo?.codigo));
                console.error('[ModeloDocumentoService] Falha ao carregar modelos do tipo', tipo?.codigo, resultado.reason);
            }
        });
        if (tiposComFalha.length > 0 && tiposComFalha.length < tiposMinuta.length) {
            MensagemStore.apresentarAviso(`Alguns tipos de minuta não foram carregados: ${tiposComFalha.join(', ')}.`);
        } else if (tiposComFalha.length === tiposMinuta.length && tiposMinuta.length > 0) {
            throw new Error('Falha ao carregar modelos de minuta.');
        }
        modelos.sort((m1, m2) => {
            if (m1.nome < m2.nome) {
                return -1;
            }
            if (m1.nome > m2.nome) {
                return 1;
            }
            return 0;
        });
        return modelos;
    }

    nomeModeloCompare(a: IModelo, b: IModelo) {
        if (a?.nome < b?.nome) {
            return -1;
        }
        if (a?.nome > b?.nome) {
            return 1;
        }
        return 0;
    }

    async modelosDoGabinetePorTipo(siglaGabinete: string, tipoMinuta: number): Promise<IModelo[]> {
        const modelos = await ModeloDocumentoApi.modelosDoGabinetePorTipo(siglaGabinete, tipoMinuta);
        const retorno = modelos.map((modelo) => IModelo.novo(modelo))
        retorno.sort(this.nomeModeloCompare);
        return retorno;
    }

    async conteudoModeloDoProcesso(siglaGabinete, tipoMinuta, codigoModelo, identificadorProcesso: number) {
        return await ModeloDocumentoApi.conteudoModeloDoProcesso(siglaGabinete, tipoMinuta, codigoModelo, identificadorProcesso);
    }

    // async conteudoModeloPadraoDoProcesso(tipoMinuta, identificadorProcesso) {
    //     return await ModeloDocumentoApi.conteudoModeloPadraoDoProcesso(tipoMinuta, identificadorProcesso);
    // }

    async conteudoModeloPadrao(tipoMinuta) {
        return await ModeloDocumentoApi.conteudoModeloPadrao(tipoMinuta);
    }

    async conteudoModelo(orgaoJugador, tipoMinuta, codigoModelo, contenttype?) {
        return await ModeloDocumentoApi.conteudoModelo(orgaoJugador, tipoMinuta, codigoModelo, contenttype);
    }

    async alteraConteudo(orgaoJulgador, tipoMinuta, modelo, categoria) {
        return await ModeloDocumentoApi.alteraConteudo(orgaoJulgador, tipoMinuta, modelo, categoria);
    }

    async gravarModelo(orgaoJulgador: string, tipoMinuta: number, modelo, categoria, movimentoCnj) {
        return await ModeloDocumentoApi.gravarModelo(orgaoJulgador, tipoMinuta, modelo, categoria, movimentoCnj);
    }

    async excluirModelo(codigoModelo: number) {
        return await ModeloDocumentoApi.excluirModelo(codigoModelo).then(() => {
            MensagemStore.apresentarMensagem('Modelo excluído com sucesso');
        });
    }

}// charset=ISO-8859-1

export default new ModeloDocumentoService();
